import React, { Component } from 'react';
import BasicAppBar from './BasicAppBar';
import { PdfCard } from './PdfCard';
import { Grid } from '@mui/material';
import { CommentCard } from './CommentCard';
import { Box } from '@mui/material';
import FloatingActionButtons from './FloatingActionButtons';

export class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {
            discussRec: [],
            docLoaded: false,
            commentRec: [],
            isError: false,
            isDataLoaded: false
        };
        this.fetchData = this.fetchData.bind(this);
        this.callbackDecision = this.callbackDecision.bind(this);
        this.callbackIsDocLoaded = this.callbackIsDocLoaded.bind(this);
        this.callbackComment = this.callbackComment.bind(this);
        this.callbackError = this.callbackError.bind(this);
    }

    static displayName = Home.name;

    async callbackError(err) {
        this.setState({isError: err})
    }

    async callbackComment(comment) {
        this.setState({ commentRec: comment })
    }

    async callbackDecision() {
        this.fetchData();
    }

    async callbackIsDocLoaded() {
        this.setState({ docLoaded: true })
    }

    async componentDidMount() {
        this.fetchData();
    }

    async fetchData() {
        const res = await fetch("/api/discussionweb/" + this.props.discussionIdentifier, {
            headers: {
                "ClientIdentifier": this.props.clientIdentifier
            }
        });
        if (res.status === 200) {
            const results = await res.json();
            var obj = JSON.parse(results);
            this.setState({ discussRec: obj, isDecisioned: obj.isDecisioned, isDataLoaded: true });
        }
    }

    render() {
        const { docLoaded, discussRec, commentRec, isError, isDataLoaded } = this.state;
        if (isDataLoaded === true) {
            return (
                <Box sx={{ flexGrow: 1 }}>
                    <BasicAppBar title="Document Collaboration" />
                    <Grid container spacing={1}>
                        <Grid item md={8}>
                            <PdfCard
                                discussionIdentifier={this.props.discussionIdentifier}
                                clientIdentifier={discussRec.clientIdentifier}
                                docLoaded={docLoaded}
                                discussRec={discussRec}
                                docLoadCallback={this.callbackIsDocLoaded}
                            />
                        </Grid>
                        <Grid item md={4}>
                            <CommentCard
                                discussionIdentifier={this.props.discussionIdentifier}
                                clientIdentifier={discussRec.clientIdentifier}
                                userIdentifier={this.props.userIdentifier}
                                docLoaded={docLoaded}
                                discussRec={discussRec}
                                callbackComment={this.callbackComment}
                                isError={isError}
                                errorCallback={this.callbackError}
                            />
                            <FloatingActionButtons
                                discussionIdentifier={this.props.discussionIdentifier}
                                clientIdentifier={discussRec.clientIdentifier}
                                userIdentifier={this.props.userIdentifier}
                                userType={this.props.userType}
                                docLoaded={docLoaded}
                                discussRec={discussRec}
                                decisionCallback={this.callbackDecision}
                                commentRec={commentRec}
                                errorCallback={this.callbackError}
                            />
                        </Grid>
                    </Grid>
                </Box>
            );
        }
    }
}